<div class="searchbar-whereapp">
    <div id="new-sender-div">
        <button id="new-sender-button" (click)="openNewSenderDialog()">
            <mat-icon aria-hidden="false" id="new-sender-icon">add</mat-icon>
            <span id="new-sender-text">Inserisci Mittente</span>
        </button>
    </div>
    <div id="search-div">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <input spellcheck="false" type="text" #filter [(ngModel)]="filterValue" placeholder="Filtra per parole chiave"
            (keydown)="onSearchKeydown($event)">
        <i class="fa fa-times" aria-hidden="true" (click)="onFilterClear();onFiltering()"></i>
        <button mat-stroked-button (click)="onFiltering()" class="ml-2" [disabled]="filterValue.length < 4 && filterValue.length > 0">Cerca</button>
    </div>

    <div id="pagination-div">
        <mat-paginator #paginator [hidePageSize]="true" [pageIndex]="pageable.pageable.pageNum"
            [pageSize]="pageable.pageable.pageSize" [length]=totalElements (page)="onPagination($event)"
            [showFirstLastButtons]="true">
        </mat-paginator>
    </div>
</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div class="empty-list" *ngIf="emptyList">
    <span>Nessun mittente trovato.</span>
</div>

<div id="main-container">
    <!-- Tabella mittenti -->
    <mat-table [dataSource]="dataSource" matSort  [matSortActive]="paginatorConfig.getFilterColumn()" [matSortDirection]="paginatorConfig.getFilterDirection()" [matSortStart]="paginatorConfig.getFilterDirection()" matSortDisableClear
        (matSortChange)="onSortChange($event)">
        <!-- Status -->
        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef fxFlex="5%" fxFlex.sm="5%" fxFlex.xs="5%" class="mobile-large">
            </mat-header-cell>
            <mat-cell *matCellDef="let sender" fxFlex="5%" fxFlex.sm="5%" fxFlex.xs="5%" class="contract-icon">
                <mat-icon *ngIf="getContractStatus(sender) == 0" class="contract-ok-icon" [inline]="true"
                    matTooltip="Il contratto è ok." aria-hidden="false" aria-label="Icona alert contratto in scadenza">
                    check_circle
                </mat-icon>
                <mat-icon *ngIf="getContractStatus(sender) == 1" class="contract-alert-icon" [inline]="true"
                    matTooltip="Attenzione, il contratto è in scadenza." aria-hidden="false"
                    aria-label="Icona alert contratto in scadenza">warning</mat-icon>
                <mat-icon *ngIf="getContractStatus(sender) == 2" class="contract-error-icon" [inline]="true"
                    matTooltip="Attenzione, il contratto è scaduto." aria-hidden="false"
                    aria-label="Icona alert contratto in scadenza">warning</mat-icon>
            </mat-cell>
        </ng-container>
        <!-- Name -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef fxFlex="50%" fxFlex.sm="50%" fxFlex.xs="50%" class="mobile-large"
                mat-sort-header>
                Nome </mat-header-cell>
            <mat-cell *matCellDef="let sender" fxFlex="50%" fxFlex.sm="50%" fxFlex.xs="50%" class="mobile-large">
                <img src="data:image/png;base64,{{ sender.logo }}" width="40px" height="40px" class="mr-2"
                    style="border-radius: 50%;" />
                {{sender.name}}
            </mat-cell>
        </ng-container>
        <!-- Email -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef fxFlex="30%" fxFlex.sm="30%" fxFlex.xs="30%" class="mobile-large"
                mat-sort-header>
                Email </mat-header-cell>
            <mat-cell *matCellDef="let sender" fxFlex="30%" fxFlex.sm="30%" fxFlex.xs="30%" class="mobile-large">
                {{sender.email}}
            </mat-cell>
        </ng-container>
        <!-- Expiration -->
        <ng-container matColumnDef="contractEndDate">
            <mat-header-cell *matHeaderCellDef fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="mobile-large"
                mat-sort-header>
                Scadenza
            </mat-header-cell>
            <mat-cell *matCellDef="let sender" fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="mobile-large">
                {{sender.contractEndDate | date:"short"}}
            </mat-cell>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="mobile-large">
            </mat-header-cell>
            <mat-cell *matCellDef="let sender" fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="contract-icon">
                <button type="button" mat-stroked-button matTooltip="Dettagli" [matTooltipShowDelay]="600"
                    (click)="onSenderDetails(sender)">
                    <mat-icon fontSet="material-icons" style="color: grey;">edit</mat-icon>
                </button>
                <!-- <button type="button" mat-stroked-button matTooltip="Operazione proibita."
                    [matTooltipShowDelay]="600" color="warn" style="margin-left: 10px;"
                    (click)="onSenderDelete(sender)" [disabled]="true">
                    <mat-icon>delete</mat-icon>
                </button> -->
            </mat-cell>
        </ng-container>

        <!-- Impostazione di righe e colonne -->
        <mat-header-row *matHeaderRowDef=" displayedColumns; sticky: true" style="height: 64px">
        </mat-header-row>

        <mat-row class="element-row" *matRowDef="let row; columns: displayedColumns; let i = index"></mat-row>
        <!-- <mat-row class="temp-element-row" *matRowDef="let row; columns: displayedColumns; let i = index"></mat-row> -->

    </mat-table>
</div>

<div class="loading" *ngIf="sub === true">
</div>
